import { render, staticRenderFns } from "./FieldTextList.vue?vue&type=template&id=1b8ed103&scoped=true"
import script from "./FieldTextList.vue?vue&type=script&lang=js"
export * from "./FieldTextList.vue?vue&type=script&lang=js"
import style0 from "./FieldTextList.vue?vue&type=style&index=0&id=1b8ed103&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ed103",
  null
  
)

export default component.exports